// extracted by mini-css-extract-plugin
export default {"headerRootOverlay":"GlobalHeader_headerRootOverlay__MTFhY"};